import React, { useState } from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface SidebarSearchProps {
    onSearch: (query: string) => void;
    isOpen: boolean;
}

const SidebarSearch: React.FC<SidebarSearchProps> = ({ onSearch, isOpen }) => {
    const [query, setQuery] = useState('');

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setQuery(value);
        onSearch(value);
    };

    const clearSearch = () => {
        setQuery('');
        onSearch('');
    };

    if (!isOpen) {
        return (
            <div className="flex justify-center py-4">
                <Search className="h-5 w-5 text-sidebar-foreground/60" />
            </div>
        );
    }

    return (
        <div className="px-4 py-4">
            <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none transition-colors group-focus-within:text-harvest-primary">
                    <Search className="h-4 w-4 text-sidebar-foreground/40" />
                </div>
                <Input
                    type="text"
                    placeholder="Filter menu..."
                    value={query}
                    onChange={handleSearch}
                    className={cn(
                        "pl-10 pr-8 bg-sidebar-accent/30 border-sidebar-border hover:border-harvest-primary/50 focus-visible:ring-harvest-primary/30 h-9 text-sm transition-all duration-300",
                        query && "border-harvest-primary/50 bg-sidebar-accent/50"
                    )}
                />
                {query && (
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={clearSearch}
                        className="absolute inset-y-0 right-0 h-9 w-8 text-sidebar-foreground/40 hover:text-harvest-error"
                        title="Clear search"
                    >
                        <X className="h-3 w-3" />
                    </Button>
                )}
            </div>
        </div>
    );
};

export default SidebarSearch;
